'use client'

import { useLayoutEffect } from 'react'

// Keep the unlocked page's actual width, including gutters that a browser
// may stop reserving during a Radix modal lock. No React render is needed.
export default function PageScrollbarWidth() {
  useLayoutEffect(() => {
    const body = document.body
    const property = '--gf-page-scrollbar-width'
    const previous = body.style.getPropertyValue(property)
    const measure = () => {
      // Never replace the saved gap with the already-expanded locked width.
      if (body.hasAttribute('data-scroll-locked')) return
      const gap = Math.max(
        0,
        window.innerWidth - body.getBoundingClientRect().width,
      )
      body.style.setProperty(property, `${gap}px`)
    }

    measure()
    const resize = new ResizeObserver(measure)
    resize.observe(body)
    const locks = new MutationObserver(measure)
    locks.observe(body, {
      attributes: true,
      attributeFilter: ['data-scroll-locked'],
    })
    window.addEventListener('resize', measure)
    // Capture the latest geometry before a pointer-triggered modal can lock.
    document.addEventListener('pointerdown', measure, true)
    document.addEventListener('keydown', measure, true)

    return () => {
      resize.disconnect()
      locks.disconnect()
      window.removeEventListener('resize', measure)
      document.removeEventListener('pointerdown', measure, true)
      document.removeEventListener('keydown', measure, true)
      if (previous) body.style.setProperty(property, previous)
      else body.style.removeProperty(property)
    }
  }, [])

  return null
}
